<template>
  <div class="admin-page" :style="bgStyle">
    <a href="https://www.movistar.com.mx/empresas" target="_blank" class="link-sitio">https://www.movistar.com.mx/empresas</a>
    <div class="admin-content">
      <div class="admin-card">
        <img
          :src="isMobile ? '/ejecutivo/logo movil.png' : '/ejecutivo/logotipo.png'"
          alt="Movistar Empresas"
          class="admin-logo"
        />
        <h1 class="admin-title font-light">Bienvenido</h1>
        <div class="admin-download">
          <p class="download-label">Descarga base de datos:</p>
          <a :href="exportUrl" class="btn-download" target="_blank">Aquí</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegistroClientesAdmin',
  data() {
    return {
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    bgStyle() {
      const img = this.isMobile ? '/ejecutivo/fondo_actual_movil1.jpg' : '/ejecutivo/fondo_actual_pc1.jpg';
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: this.isMobile ? 'top center' : 'center center'
      }
    },
    exportUrl() {
      return this.$api.baseUri + 'ejecutivo/leads/export/web';
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768;
    }
  }
}
</script>

<style scoped>
.admin-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  overflow-x: hidden;
  position: relative;
}

.link-sitio {
  position: absolute;
  bottom: 80px;
  left: 20%;
  transform: translateX(-50%);
  color: rgba(255,255,255,0.7);
  font-size: clamp(14px, 1.2vw, 17px);
  font-family: TelefonicaRegular, sans-serif;
  text-decoration: none;
  z-index: 10;
}
.link-sitio:hover {
  color: #fff;
  text-decoration: underline;
}

.admin-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 20vw;
}

.admin-card {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.admin-logo {
  width: clamp(280px, 30vw, 480px);
  height: auto;
  margin-bottom: clamp(30px, 4vw, 60px);
}

.admin-title {
  color: #fff;
  font-size: clamp(32px, 3.5vw, 54px);
  margin: 0 0 clamp(40px, 5vw, 80px);
  font-family: TelefonicaLight, sans-serif;
}

.admin-download {
  text-align: center;
}

.download-label {
  color: #fff;
  font-size: clamp(16px, 1.4vw, 22px);
  font-weight: bold;
  margin-bottom: clamp(14px, 1.5vw, 24px);
  font-family: TelefonicaRegular, sans-serif;
}

.btn-download {
  display: inline-block;
  width: clamp(180px, 16vw, 280px);
  padding: clamp(12px, 1.2vw, 20px) clamp(30px, 3vw, 50px);
  border: none;
  border-radius: 30px;
  background: #E535AB;
  color: #fff;
  font-size: clamp(20px, 1.8vw, 30px);
  cursor: pointer;
  transition: background 0.25s;
  font-family: TelefonicaRegular, sans-serif;
  text-decoration: none;
  text-align: center;
}

.btn-download:hover {
  background: #c92d96;
}

/* MOBILE */
@media (max-width: 768px) {
  .admin-content {
    padding-left: 0;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 24px 28px 40px;
  }
  .admin-logo {
    width: 220px;
    margin-bottom: 40vh;
  }
  .admin-title {
    font-size: 26px;
    margin-bottom: 30px;
  }
  .download-label {
    font-size: 16px;
  }
  .btn-download {
    width: 150px;
    padding: 10px;
    font-size: 14px;
  }
  .link-sitio {
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 11px;
    text-align: center;
  }
}
</style>
